import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropdownItems from './DropdownItems';
var DropdownButton = function DropdownButton(_ref) {
  var text = _ref.text,
    items = _ref.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown rubriq-dropdown d-inline-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link dropdown-toggle rubriq-btn ms-4 ms-sm-0",
    type: "button",
    id: "rubriqDropdownButton",
    "data-bs-toggle": "dropdown"
  }, /*#__PURE__*/React.createElement("span", null, text, " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-down"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu p-0",
    "aria-labelledby": "rubriqDropdownButton"
  }, /*#__PURE__*/React.createElement(DropdownItems, {
    items: items
  })));
};
export default DropdownButton;